<div class="response table-responsive m-b-2">
    <table class="est-table" cellspacing="0">
        <tbody>
            <!-- Use Angular's keyvalue pipe to iterate over object keys -->

            <tr>
                <td>Property Uid</td>
                <td>{{response?.property_uid || '-'}}</td>
            </tr>
            <tr>
                <td>Land Frontage</td>
                <td>{{response?.land_frontage || '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Midpoint</td>
                <td>{{response?.land_value_midpoint ? (response?.land_value_midpoint | number : "1.0-1") : '-'}}</td>
            </tr>           
            <tr>
                <td>Land Value Lower Range</td>
                <td>{{response?.land_value_lower_range ? (response?.land_value_lower_range | number : "1.0-1") : '-'}}</td>
            </tr>
            <tr>
                <td>Land Value Higher Range</td>
                <td>{{response?.land_value_higher_range ? (response?.land_value_higher_range | number : "1.0-1")  : '-'}}</td>
            </tr>
             <tr>
                <td>Project Name</td>
                <td>{{response?.project_name || '-'}}</td>
            </tr>
            <tr>
                <td>Property Build Year</td>
                <td>{{response?.property_build_year || '-'}}</td>
            </tr>
            <tr>
                <td>Property Age</td>
                <td>{{response?.property_age || '-'}}</td>
            </tr>
            <tr>
                <td>Number Of Square Corners</td>
                <td>{{response?.number_of_square_corners || '-'}}</td>
            </tr>
            <tr>
                <td>Number Of Bevelled Corners</td>
                <td>{{response?.number_of_bevelled_corners || '-'}}</td>
            </tr>
            <tr>
                <td>Total Open Frontage</td>
                <td>{{response?.total_open_frontage || '-'}}</td>
            </tr>
            <tr>
                <td>Percentage Length Open</td>
                <td>{{response?.percentage_length_open || '-'}}</td>
            </tr>
            <tr>
                <td>Land Area</td>
                <td>{{response?.land_area ? (response?.land_area | number : "1.0-1"): "-"}}</td>
            </tr>

            <tr>
                <td>Neigh Name</td>
                <td>{{response?.neigh_name || '-'}}</td>
            </tr>
            <tr>
                <td>Block Name</td>
                <td>{{response?.block_name || '-'}}</td>
            </tr>
            <tr>
                <td>Street Name</td>
                <td>{{response?.street_name || '-'}}</td>
            </tr>
        </tbody>
    </table>
    @if(direction){
        <table class="w-100" cellspacing="0">
            <tbody>
                <tr>
                    <td>Land Frontage Direction Orientation</td>
                    <td>
                        <table class="child-table w-100" cellspacing="0">
                            <thead>
                                <tr>
                                    @for (agrKey of direction | keyvalue ; track $index) {
                                    <th class="text-uppercase">{{agrKey.key}}</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                @for (agrVal of direction | keyvalue ; track $index) {
                                <td>{{agrVal.value ? agrVal.value : '-'}}</td>
                                }
                            </tbody>
                        </table>
                    </td>
                </tr>
            
            </tbody>
        </table>
    }
  
</div>